/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  var ADS_TAG_ID = 'AW-362881502';
  var ADS_QUOTE_CONVERSION_LABEL = 'AW-362881502/0il8CMHWsoMcEN7DhK0B';

  function ensureAdsTag() {
    if (window.__colvinAdsTagRequested) {
      return;
    }

    window.__colvinAdsTagRequested = true;
    window.dataLayer = window.dataLayer || [];

    if (typeof window.gtag !== 'function') {
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
    }

    window.gtag('js', new Date());
    window.gtag('config', ADS_TAG_ID, { send_page_view: false });

    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + ADS_TAG_ID;
    document.head.appendChild(script);
  }

  function trackQuoteConversion(quoteNumber) {
    try {
      ensureAdsTag();

      var payload = {
        send_to: ADS_QUOTE_CONVERSION_LABEL,
        value: 1.0,
        currency: 'CLP'
      };

      if (quoteNumber) {
        payload.transaction_id = String(quoteNumber);
      }

      window.gtag('event', 'conversion', payload);
    } catch (error) {
      // La conversión de Ads nunca debe romper el flujo del formulario.
    }
  }

  function setQuoteStatus(container, message, state) {
    var statusNode = container.querySelector('[data-quote-status]');

    if (!statusNode) {
      return;
    }

    statusNode.textContent = message || '';
    statusNode.dataset.state = state || '';
  }

  function getQuoteField(container, name) {
    return container.querySelector('[name="' + name + '"]');
  }

  function buildQuoteFormData(container) {
    var formData = new FormData();

    container.querySelectorAll('input, textarea, select').forEach(function(field) {
      if (!field.name || field.disabled) {
        return;
      }

      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) {
        return;
      }

      formData.append(field.name, field.value);
    });

    formData.append('first_name', getQuoteField(container, 'nombre') ? getQuoteField(container, 'nombre').value.trim() : '');
    formData.append('last_name', getQuoteField(container, 'apellido') ? getQuoteField(container, 'apellido').value.trim() : '');
    formData.append('business_name', getQuoteField(container, 'razon_social') ? getQuoteField(container, 'razon_social').value.trim() : '');
    formData.append('company_rut', getQuoteField(container, 'rut_empresa') ? getQuoteField(container, 'rut_empresa').value.trim() : '');
    formData.append('business_activity', getQuoteField(container, 'giro') ? getQuoteField(container, 'giro').value.trim() : '');
    formData.append('phone', getQuoteField(container, 'telefono') ? getQuoteField(container, 'telefono').value.trim() : '');
    formData.append('message', getQuoteField(container, 'mensaje') ? getQuoteField(container, 'mensaje').value.trim() : '');
    formData.append('product_title', container.dataset.productTitle || '');
    formData.append('product_handle', container.dataset.productHandle || '');
    formData.append('product_url', container.dataset.productUrl || '');

    return formData;
  }

  function validateQuoteForm(container) {
    var requiredFields = ['nombre', 'apellido', 'razon_social', 'rut_empresa', 'giro', 'direccion', 'email', 'telefono', 'mensaje', 'sku'];

    for (var i = 0; i < requiredFields.length; i += 1) {
      var field = getQuoteField(container, requiredFields[i]);

      if (!field || !field.value.trim()) {
        setQuoteStatus(container, 'Completa todos los campos.', 'error');
        return false;
      }
    }

    var emailField = getQuoteField(container, 'email');

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailField.value.trim())) {
      setQuoteStatus(container, 'Ingresa un email valido.', 'error');
      return false;
    }

    if (!container.dataset.recaptchaSiteKey) {
      setQuoteStatus(container, 'Falta configurar reCAPTCHA.', 'error');
      return false;
    }

    if (typeof window.grecaptcha === 'undefined') {
      setQuoteStatus(container, 'reCAPTCHA aun no carga.', 'error');
      return false;
    }

    return true;
  }

  function resetQuoteForm(container) {
    container.querySelectorAll('input, textarea').forEach(function(field) {
      if (field.type === 'hidden') {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = false;
        return;
      }

      field.value = '';
    });
  }

  function waitForRecaptcha() {
    return new Promise(function(resolve, reject) {
      if (typeof window.grecaptcha === 'undefined' || typeof window.grecaptcha.ready !== 'function') {
        reject(new Error('reCAPTCHA aun no carga.'));
        return;
      }

      window.grecaptcha.ready(resolve);
    });
  }

  async function getRecaptchaToken(container) {
    await waitForRecaptcha();

    return window.grecaptcha.execute(container.dataset.recaptchaSiteKey, {
      action: 'request_quote'
    });
  }

  function initQuoteRecaptchas(root) {
    if (typeof window.grecaptcha === 'undefined') {
      return;
    }

    (root || document).querySelectorAll('[data-quote-form]').forEach(function(container) {
      if (!container.dataset.recaptchaSiteKey) {
        return;
      }

      container.dataset.recaptchaReady = 'true';
    });
  }

  window.codexInitQuoteRecaptcha = function() {
    initQuoteRecaptchas(document);
  };

  if (typeof window !== 'undefined') {
    var existingRecaptchaScript = document.querySelector('script[src*="google.com/recaptcha/api.js"]');

    if (existingRecaptchaScript) {
      existingRecaptchaScript.addEventListener('load', function() {
        initQuoteRecaptchas(document);
      });
    }
  }

  document.addEventListener('click', async function(event) {
    var submitButton = event.target.closest('[data-quote-submit]');

    if (!submitButton) {
      return;
    }

    var container = submitButton.closest('[data-quote-form]');

    if (!container) {
      return;
    }

    if (!validateQuoteForm(container)) {
      return;
    }

    submitButton.disabled = true;
    setQuoteStatus(container, 'Enviando...', 'loading');

    try {
      var formData = buildQuoteFormData(container);
      var recaptchaToken = await getRecaptchaToken(container);

      formData.append('g-recaptcha-response', recaptchaToken);
      formData.append('recaptcha_action', 'request_quote');

      var response = await fetch(container.dataset.endpoint, {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      });

      var data = await response.json();

      if (!response.ok) {
        throw new Error(data && data.error && data.error.message ? data.error.message : 'Quote request failed');
      }

      resetQuoteForm(container);
      setQuoteStatus(container, data && data.quote_number ? 'Cotizacion recibida: ' + data.quote_number : 'Cotizacion enviada.', 'success');
      trackQuoteConversion(data && data.quote_number);
    } catch (error) {
      setQuoteStatus(container, error && error.message ? error.message : 'Error enviando formulario.', 'error');
    } finally {
      submitButton.disabled = false;
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    initQuoteRecaptchas(document);

    if (document.querySelector('[data-quote-form]')) {
      ensureAdsTag();
    }
  });

  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail && event.detail.variant;
    var productForm = event.target && event.target.closest ? event.target.closest('product-form') : null;

    if (!variant || !productForm) {
      return;
    }

    var quoteForm = productForm.querySelector('[data-quote-form]');
    var skuInput = quoteForm ? quoteForm.querySelector('[data-quote-sku]') : null;

    if (skuInput) {
      skuInput.value = variant.sku || '';
    }
  });

  document.addEventListener('product:rerender', function() {
    initQuoteRecaptchas(document);
  });
})();
